import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

interface CollectionItemsStylesClasses {
  card: string;
  cardHeader: string;
  cardTitle: string;
  cardItems: string;
  paginationUl: string;
  selected: string;
}

const useCollectionItemsStyles = makeStyles<Theme>((theme) => ({
  card: {
    backgroundColor: theme.palette.background.paper,
    paddingBottom: theme.spacing(2),
    overflow: 'auto',
    maxHeight: '100vh',
    minHeight: '100%',
  },
  cardHeader: {
    height: 140,
    position: 'sticky',
    top: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    zIndex: 100,
    backgroundColor: theme.palette.background.paper,
  },
  cardTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  cardItems: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  paginationUl: {
    justifyContent: 'center',
  },
  selected: {
    backgroundColor: theme.palette.action.selected,
    color: theme.palette.primary.main,
  },
}));

export type { CollectionItemsStylesClasses };
export default useCollectionItemsStyles;
